import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { take } from 'rxjs';
import { RouterLink } from '@angular/router';

import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ValuesService } from '@app/common/values/values.service';
import * as constants from "@app/shared/constants";
import { C_value } from "@app/shared/_models/common";
import { ProductPackagingVal } from '@app/shared/_models/product';


@Component({
  selector: 'app-not-selling-dialog',
  standalone: true,
  styleUrls: ['./notSellingDialog.component.scss'],
  imports: [MatDialogModule, MatDialogContent, MatDialogActions, MatButtonModule, MatIconModule, RouterLink],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './notSellingDialog.component.html'
})
export class NotSellingDialog implements OnInit {

  packaging: C_value[] = [];

  constructor(
    private valuesService: ValuesService,
    public dialogRef: MatDialogRef<NotSellingDialog>,
    @Inject(MAT_DIALOG_DATA) public ppv: ProductPackagingVal
  ) {}

  ngOnInit(): void {
    this.valuesService.getValues$(constants.C_VALUES_UOM).pipe(take(1)).subscribe(vals => {
      this.packaging = vals;
    });
  }

  getPackagingName(packagingId: number | undefined): string {
    if (!packagingId) return '—';
    return this.packaging.find(p => p.id === packagingId)?.name ?? '—';
  }

  onAdd(doAdd: boolean) {
    this.dialogRef.close(doAdd);
  }
}
